/**
 * Reference media, fetched once and kept (owner, 2026-10-18: testers saw the
 * reference video and audio open and play late).
 *
 * The service worker keeps `/nest-media/reference…` in its `reference-media`
 * cache (vite.config.js, cache-first: the URLs are immutable). A player only
 * ever asks for byte ranges, though, and a ranged (206) answer cannot be
 * cached — so the page fetches the whole file once itself, the worker stores
 * that, and from then on the player's ranges are cut from the cache.
 *
 * One fetch per URL per page load, however many times it is asked for.
 */
const warmed = new Map()

export function prefetchMedia(url, fetcher = globalThis.fetch?.bind(globalThis)) {
  if (!url || typeof fetcher !== 'function') return Promise.resolve(false)
  if (!warmed.has(url)) {
    warmed.set(
      url,
      Promise.resolve()
        .then(() => fetcher(url))
        .then(async (response) => {
          if (!response?.ok) return false
          // Read to the end: the worker caches the body as it streams through.
          await response.arrayBuffer()
          return true
        })
        .catch(() => false),
    )
  }
  return warmed.get(url)
}

/** A worker is answering this page — only then does a prefetch make the player's later ranges free. */
export function hasServiceWorker() {
  return Boolean(globalThis.navigator?.serviceWorker?.controller)
}

/** For tests: forget what was fetched. */
export function resetPrefetched() {
  warmed.clear()
}
